import React from 'react';
import './IntroLayer.css';
import IntroStart from './IntroStart';

const INTRO_TIME = 4500; // milliseconds

export default function IntroLayer(props) {
  const {
    currentLocation,
    loadedGallery,
    onEndIntroHandler,
    isAppReady,
    isAppAxlStarted,
    isSharedDefault,
  } = props;

  const isWaitingForGalleryData = () => {
    return !loadedGallery || (!loadedGallery.default && !currentLocation);
  };

  const isReadyForTimer = () => {
    return isAppAxlStarted && isAppReady;
  };

  const [open, setOpen] = React.useState(true);
  const [closing, setClosing] = React.useState(false);
  const [empty, setEmpty] = React.useState(isWaitingForGalleryData());

  React.useEffect(() => {
    setEmpty(isWaitingForGalleryData());

    if (isReadyForTimer() && open) {
      setTimeout(() => {
        setClosing(true);
        onEndIntroHandler();
        setTimeout(() => {
          setOpen(false);
        }, 1000);
      }, INTRO_TIME);
    }
  });

  if (empty) {
    return <></>;
  }

  return (
    open && (
      <>
        <div className={`overlay ${!closing ? ' overlay--activated' : ''}`} />
        <div id="intro" className={closing ? 'bye' : ''}>
          <IntroStart
            isSharedDefault={isSharedDefault}
            loading={!isAppReady}
            currentLocation={currentLocation}
            loadedGallery={loadedGallery}
          />
        </div>
      </>
    )
  );
}
